import { TextField, styled } from "@mui/material";

const StyledTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.input_field,
  "& fieldset": {
    border: "none",
  },
}));

export default StyledTextField;